window.initStream = function() {
    let data = {
        ws: null,
        streams_index: null,
        streams: [],
        chat_interface_hidden: true,
        gift_menu_open: false,
        stream: {},
        following: false,
        chat: {
            last_id: -1,
            messages: []
        },
        new_message: {
            text: ''
        },
        keepalive_timer: null,
        ping_timer: null,
        target_timer: null,
        gifts_config: {},
        guest_mode: false,
        messages_sent: 0,
        GAME_ROLE_SPECTATOR: 'spectator',
        GAME_ROLE_PLAYER: 'player',
        shutting_down: false,
        first_stream_joined: false
    }

    window.streamingApp = new Vue({
        el: '#streamingApp',
        data: data,
        mixins: [window.vue_mixin_streaming_app_data],
        methods: {
            initWs: function () {
                let self = this;
                let socket = io(self.config.WS_LOCATION);
                let hello = {
                    type: 1,
                    id: self.me.id,
                    username: self.me.name,
                };

                socket.on('connect', function () {
                    socket.emit('hello', hello);
                    socket.emit('subscribe', {id: 'streams'});
                    if (self.stream && self.stream.channel) {
                        socket.emit('subscribe', {id: self.stream.channel});
                    }
                });
                socket.on('connect_error', function (err) {
                    console.error('Failed to connect to the server');
                    console.error(err);
                });
                socket.on('stream_message', function (err) {
                    self.getMessages();
                });
                socket.on('stream_video_start', function (data) {
                    if (data.channel_id === self.stream.channel) {
                        self.stopVideo();
                        self.getStreams()
                            .then(function () {
                                Vue.nextTick(function () {
                                    self.stream.video_id = data.video_stream_id;
                                    let idx = self.streams.findIndex((v) => v.id == self.stream.id);
                                    self.streams[idx].video_id = data.video_stream_id;
                                    self.initVideo();
                                })
                            });
                    }
                });
                socket.on('stream_video_stop', function (data) {
                    if (data.channel_id === self.stream.channel) {
                        self.stopVideo();
                    }
                });
                socket.on('running_game', function (data) {
                    if (data.channel_id === self.stream.channel) {
                        self.startGame(
                            data.type_id,
                            data.player_id === self.me.id ? self.GAME_ROLE_PLAYER : self.GAME_ROLE_SPECTATOR,
                            { player_id: data.player_id, player_name: data.player_name }
                        );
                    }
                });

                self.ws = socket;
            },
            setStream: function (stream) {
                this.stream = {
                    id: stream.id,
                    channel: stream.channel,
                    video_id: stream.video_id,
                    gifts_count: stream.gifts_count || 0,
                    lvm_ref: null,
                    user_name: stream.user_name || null,
                    user_photo: stream.user_photo || null,
                    user_photo_w: stream.user_photo_w || null,
                    user_photo_h: stream.user_photo_h || null,
                    user_is_fav: stream.user_is_fav || null,
                    user_link: stream.user_link || null,
                    user_gender: stream.user_gender || null,
                    user_letter: stream.user_letter || null,
                    user_private_chat: stream.user_private_chat || null,
                    user_diamonds: stream.user_diamonds || 0,
                    user_diamonds_target: stream.user_diamonds_target || null,
                    user_diamonds_target_action: stream.user_diamonds_target_action || null,
                    audio_muted: false,
                    running: false,
                    playing: false,
                    chat_init: false,
                    last_known_game: stream.game
                }
                this.following = stream.following;
            },
            initVideo: function () {
                this.stream.running = true;
            },
            initChat: function () {
                let self = this;
                let first_time = !this.stream.chat_init;
                this.stream.chat_init = true;
                this.getMessages();
                this.ws.emit('subscribe', {id: this.stream.channel});
                let data = {
                    action: 'watch_start',
                    host_id: self.stream.id,
                    silent: (first_time ? 0 : 1)
                };
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: data
                });
                if(!this.first_stream_joined) {
                    this.first_stream_joined = true;
                    this.remindGifts();
                }
            },
            stopVideo: function () {
                this.stream.running = false;
            },
            clearPopups: function() {
                this.$refs.uiDialog.no();
                this.$refs.uiTooltipDiamondTarget.no();
                this.$refs.uiTooltipVirtualGift.ok();
            },
            stopChat: function () {
                let self = this;
                self.chat_interface_hidden = true;
                this.stopPing();
                this.clearPopups();
                let d = {
                    action: 'watch_stop',
                    host_id: self.stream.id
                };
                if ('sendBeacon' in navigator) {
                    navigator.sendBeacon('/streaming.ajax.php', new URLSearchParams(d));
                } else {
                    $.ajax({
                        method: 'POST',
                        url: '/streaming.ajax.php',
                        data: d
                    });
                }
                self.ws.emit('unsubscribe', {id: this.stream.channel});
                self.chat = {
                    last_id: -1,
                    messages: []
                };
            },
            nextStream: function (step) {
                let self = this;
                this.stopVideo();
                this.stopChat();

                Vue.nextTick(function () {
                    self.streams_index += step;
                    if (self.streams_index > self.streams.length - 1) {
                        self.streams_index = 0
                    }
                    if (self.streams_index < 0) {
                        self.streams_index = self.streams.length - 1
                    }
                    self.setStream(self.streams[self.streams_index]);
                    self.initVideo();
                })
            },
            muteAudio: function () {
                this.stream.audio_muted = true;
                if (this.stream.lvm_ref) {
                    live_video_module.muteAudio(this.stream.lvm_ref);
                }
            },
            unmuteAudio: function () {
                this.stream.audio_muted = false;
                if (this.stream.lvm_ref) {
                    live_video_module.unmuteAudio(this.stream.lvm_ref);
                }
            },
            ping: function () {
                let self = this;
                let data = {
                    action: 'ping',
                    host_id: self.stream.id,
                    f_date: self.f_date || ''
                };
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: data,
                    dataType: 'json',
                    complete: function(res, status) {
                        self.credits = res.responseJSON.credits;
                        if('diamonds' in res.responseJSON) {
                            self.me.diamonds = res.responseJSON.diamonds;
                        }
                        if(res.status == 402) {
                            let message = '';
                            self.stopPing();
                            self.pauseVideo();

                            if(self.guest_mode) {
                                const event = new CustomEvent('streaming:is_guest', {detail: {source: 'ping', name: self.stream.user_name}});
                                window.dispatchEvent(event);
                                return;
                            }
                            if(res.responseJSON.consent_needed) {
                                message = self.lang.billing_warning
                                    .replace(/{name}/g, self.stream.user_name)
                                    .replace(/{x}/g, self.price_per_hour);

                                window.top.vex.dialog.confirm({
                                    message: message,
                                    buttons: [
                                        $.extend({}, window.parent.vex.dialog.buttons.NO, {
                                            text: self.lang.no
                                        }),
                                        $.extend({}, window.parent.vex.dialog.buttons.YES, {
                                            text: self.lang.yes
                                        })
                                    ],
                                    callback: function(r) {
                                        if(!r) {
                                            if(self.streams.length <= 1) {
                                                document.location.href = self.online_users_url;
                                            } else {
                                                document.location.href = self.streaming_list_url;
                                            }
                                            return;
                                        }
                                        $.ajax({
                                            method: 'POST',
                                            url: '/streaming.ajax.php',
                                            data: {
                                                action: 'consent',
                                                streamer: self.stream.id || ''
                                            },
                                            success: function () {
                                                self.startPing();
                                                self.resumeVideo();
                                            },
                                            error: function () {
                                                document.location.href = self.online_users_url;
                                            }
                                        });
                                    }
                                });
                            } else {
                                showBuyCreditsPopup({
                                    heading: self.lang.buy_credits_heading1.replace(/{name}/g, self.stream.user_name).replace(/{x}/g, self.price_per_hour),
                                    subheading: self.lang.buy_credits_subheading1,
                                    photo: self.stream.user_photo,
                                    redirect: `/streaming.php?id=${self.stream.id}`,
                                    back_redirect: self.online_users_url
                                });
                            }
                        }
                    }
                });
            },
            startPing: function() {
                let self = this;
                if(self.ping_timer) return;
                self.ping();
                self.ping_timer = window.setInterval(function () {
                    self.ping();
                }, 4000);
                self.target_timer = window.setInterval(function () {
                    self.remindDiamondsTarget();
                }, 60000 * 20);
                window.setTimeout(function () {
                    self.remindDiamondsTarget();
                }, 50);
            },
            stopPing: function() {
                let self = this;
                if(!self.ping_timer) return;
                window.clearInterval(self.ping_timer);
                window.clearInterval(self.target_timer);
                self.ping_timer = null;
                self.target_timer = null;
            },
            onVideoStart: function (a) {
                this.stream.playing = true;
                this.stream.lvm_ref = a.lvm_ref;
                this.chat_interface_hidden = false;
                this.initChat();
                this.startPing();
            },
            onVideoEnd: function () {
                this.stream.playing = false;
                this.chat_interface_hidden = true;
                this.endGame();
                this.stopPing();
            },
            pauseVideo: function () {
                this.$refs.myVideo.pause();
            },
            resumeVideo: function () {
                this.$refs.myVideo.play();
            },
            close: function () {
                this.stopVideo();
                this.stopChat();
                if(this.streams.length <= 1) {
                    document.location.href = this.online_users_url;
                } else {
                    document.location.href = this.streaming_list_url;
                }
            },
            sendMessage: function () {
                let self = this; self.messages_sent++;
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'send_message',
                        message: self.new_message,
                        channel: self.stream.channel,
                        host_id: self.stream.id
                    }
                });
                self.new_message.text = '';
            },
            getMessages: function () {
                let self = this;
                $.ajax({
                    method: 'GET',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'get_messages',
                        since_id: self.chat.last_id + 1,
                        channel: self.stream.channel,
                        host_id: self.stream.id
                    },
                    dataType: 'json'
                })
                    .then(function (data) {
                        let game_command_message = null;
                        if (Array.isArray(data.messages)) {
                            data.messages = data.messages.filter((v) => v.id > self.chat.last_id);
                        }

                        if (Array.isArray(data.messages) && data.messages.length) {
                            if(self.chat.last_id > -1) {
                                game_command_message = data.messages.find((v) => v.game && !v.is_my);
                                data.messages.forEach(function (v) {
                                    if(!v.is_my && v.diamonds) {
                                        self.stream.user_diamonds += v.diamonds;
                                    }
                                    if(v.diamonds_target) {
                                        self.stream.user_diamonds_target = v.diamonds_target.target;
                                        self.stream.user_diamonds_target_action = v.diamonds_target.action;
                                        Vue.nextTick(self.remindDiamondsTarget);
                                    }
                                    if(v.diamonds_target_reached) {
                                        self.onDiamondsTargetReached();
                                    }
                                });
                            }
                            self.chat.last_id = Math.max(...data.messages.map((v) => v.id));
                            self.chat.messages.push(...data.messages.filter((v) => !v.is_hidden));
                        } else {
                            if(self.chat.last_id === -1) {
                                self.chat.last_id = 0;
                            }
                        }

                        Vue.nextTick(function () {
                            let lm = self.$refs.chat_messages.lastElementChild;
                            if (lm) {
                                let sf = function () {
                                    self.$refs.chat_messages.scrollTo({
                                        top: self.$refs.chat_messages.scrollHeight,
                                        left: 0,
                                        behavior: 'smooth'
                                    });
                                    document.removeEventListener('visibilitychange', sf);
                                }
                                if (document.hidden) {
                                    document.addEventListener('visibilitychange', sf);
                                } else {
                                    sf();
                                }
                            }
                            if(game_command_message) {
                                switch (game_command_message.game.command) {
                                    case 'INV':
                                        if(game_command_message.from_id === self.stream.id) {
                                            self.showGameInvitation(game_command_message);
                                        }
                                        break;
                                    case 'ACC':
                                        let payload = game_command_message.game.payload.split('|');
                                        if(payload[0] === self.me.id) {
                                            self.startGame(game_command_message.game.type_id, self.GAME_ROLE_PLAYER);
                                        } else {
                                            if(game_command_message.from_id === self.stream.id) {
                                                self.startGame(game_command_message.game.type_id, self.GAME_ROLE_SPECTATOR, { player_id: payload[0], player_name: payload[1] });
                                            } else {
                                                self.startGame(game_command_message.game.type_id, self.GAME_ROLE_SPECTATOR, { player_id: game_command_message.from_id, player_name: game_command_message.from_name });
                                            }

                                            if(self.stream.game_invitation_sent && game_command_message.from_id === self.stream.id) {
                                                self.$refs.uiDialog.alert('', self.lang.games.game_already_started.replace('{name}', game_command_message.from_name));
                                            }
                                        }
                                        self.stream.game_invitation_sent = false;
                                        break;
                                    case 'WISH':
                                        self.chat.messages.push({
                                            id: -1,
                                            from_id: null,
                                            from_name: self.lang.games.the_wish.replace('{name}', game_command_message.from_name),
                                            message: game_command_message.game.payload,
                                            is_my: false
                                        });
                                        break;
                                }
                            }
                        })
                    });
            },
            startGame: function(type_id, role, options) {
                options = Object.assign({}, options || {});
                let game = {};
                if(role === this.GAME_ROLE_SPECTATOR) {
                    game = {
                        "role": role,
                        "id": "stream" + this.stream.id,
                        "type_id": type_id,
                        "player_id": options.player_id,
                        "host_id": this.stream.id,
                        "player_name": options.player_name,
                        "host_name": this.stream.user_name,
                        "created": Date.now()
                    };
                } else if(role === this.GAME_ROLE_PLAYER) {
                    game = {
                        "role": role,
                        "id": "stream" + this.stream.id,
                        "type_id": type_id,
                        "player_id": this.me.id,
                        "host_id": this.stream.id,
                        "player_name": this.me.name,
                        "host_name": this.stream.user_name,
                        "created": Date.now()
                    };
                }
                Vue.set(this.stream, 'game', game);
            },
            showGameInvitation: function (game_command_message) {
                let self = this;
                if(self.guest_mode) {
                    return;
                }
                self.$refs.uiDialog.confirm(
                    '',
                    self.lang.games.invite.replace('{name}', game_command_message.from_name)
                        .replace('{game}', self.lang.games[game_command_message.game.type_id])
                )
                    .then(function () {
                        $.ajax({
                            method: 'POST',
                            url: '/streaming.ajax.php',
                            data: {
                                action: 'game_accept',
                                type_id: game_command_message.game.type_id,
                                channel: self.stream.channel,
                                host_id: self.stream.id
                            }
                        });
                        if(!self.stream.game) {
                            self.startGame(game_command_message.game.type_id, self.GAME_ROLE_PLAYER);
                        } else {
                            self.$refs.uiDialog.alert('', self.lang.games.game_already_started.replace('{name}', game_command_message.from_name));
                        }

                    }, function () {

                    })
            },
            onTransferDiamonds: function (data) {
                let self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'send_diamonds', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                let amount = parseInt(data.amount);
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'send_diamonds',
                        amount: amount,
                        channel: self.stream.channel,
                        host_id: self.stream.id
                    }
                })
                    .then(
                        function (data) {
                            if('diamonds' in data) {
                                self.me.diamonds = data.diamonds;
                                self.stream.user_diamonds += amount;
                            }
                        }
                    );
            },
            onSendGift: function (data) {
                let self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'send_gift', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                let gift = data.gift;
                let show_bc = function () {
                    showBuyCreditsPopup({
                        heading: self.lang.buy_credits_heading.replace(/{name}/g, self.stream.user_name),
                        subheading: self.lang.buy_credits_subheading.replace(/{x}/g, gift.price),
                        icon: 'gift',
                        photo: self.stream.user_photo,
                        redirect: `/streaming.php?id=${self.stream.id}`
                    });
                }
                if ('credits' in window && window.credits < gift.price) {
                    show_bc();
                    return;
                }
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'send_gift',
                        gift: gift.id,
                        channel: self.stream.channel,
                        host_id: self.stream.id
                    }
                })
                    .then(
                        function (data) {
                            self.stream.gifts_count++;
                        },
                        function (jqXHR) {
                            if (jqXHR.status == 402) {
                                show_bc();
                            }
                        }
                    );
            },
            toggleFav: function () {
                if(this.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'toggle_fav', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                this.stream.user_is_fav = !this.stream.user_is_fav;

                let action = this.stream.user_is_fav ? 'add' : 'delete';
                let url = `${this.fav_script_url}?${action}=` + (this.stream.id ).toString();

                $.ajax({
                    method: 'get',
                    url: url
                });
            },
            getStreams: function () {
                let self = this;
                return $.ajax({
                    method: 'GET',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'get_streams'
                    },
                    dataType: 'json'
                })
                    .then(function (data) {
                        self.streams = data.streams;
                        if (self.stream.id) {
                            self.streams_index = data.streams.findIndex((v) => v.id == self.stream.id);

                            let ts_before = self.stream_target_is_set;

                            Vue.set(self.stream, 'user_diamonds', data.streams[ self.streams_index ].user_diamonds);
                            Vue.set(self.stream, 'user_diamonds_target', data.streams[ self.streams_index ].user_diamonds_target);
                            Vue.set(self.stream, 'user_diamonds_target_action', data.streams[ self.streams_index ].user_diamonds_target_action);

                            if(!ts_before && self.stream_target_is_set) {
                                self.remindDiamondsTarget();
                            }
                        }
                        if('diamonds' in data) {
                            self.me.diamonds = data.diamonds;
                        }
                    });
            },
            keepAlive: function () {
                this.getStreams();
            },
            beforeUnload: function () {
                this.shutting_down = true;
                this.stopChat();
                this.stopVideo();
            },
            goPrivate: function () {
                if (!this.stream.id) {
                    return;
                }
                const self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'go_private', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                if(window.credits) {
                    window.winchatopen(this.stream.id);
                    window.chat_invitations_module.trackChatStart(this.stream.id, window.chat_invitations_module.CHAT_START_STREAMING);
                } else {
                    window.chat_invitations_module.trackChatStart(this.stream.id, window.chat_invitations_module.CHAT_START_STREAMING);
                    showBuyCreditsPopup({
                        heading: self.lang.buy_credits_heading_private_chat.replace(/{name}/g, self.stream.user_name).replace(/{id}/g, self.stream.id),
                        icon: 'chat',
                        photo: self.stream.user_photo,
                        redirect: `/chat/index.php?gID=${self.stream.id}`
                    });
                }
            },
            goComposeLetter: function () {
                if (!this.stream.id) {
                    return;
                }
                const self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'go_private', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                window.location.href = this.compose_letter_url.replace('{id}', this.stream.id);
            },
            follow: function () {
                let self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'follow', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                if('OneSignal' in window) {
                    OneSignal.showSlidedownPrompt();
                    OneSignal.setExternalUserId(window.user_id);
                }
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'follow',
                        host_id: self.stream.id
                    },
                    success: function () {
                        self.following = true;
                        //vex.dialog.alert(self.lang.follow_ok.replace(/{name}/g, self.stream.user_name));
                    }
                });
            },
            unfollow: function () {
                let self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'unfollow', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'unfollow',
                        host_id: self.stream.id
                    },
                    success: function () {
                        self.following = false;
                    }
                });
            },
            onDiamondsBought: function(event) {
                this.me.diamonds = event.detail.balance;
            },
            inviteGame: function (type_id) {
                let self = this;
                if(self.guest_mode) {
                    const event = new CustomEvent('streaming:is_guest', {detail: {source: 'unfollow', name: self.stream.user_name}});
                    window.dispatchEvent(event);
                    return;
                }
                if(self.stream.game) {
                    return;
                }
                $.ajax({
                    method: 'POST',
                    url: '/streaming.ajax.php',
                    data: {
                        action: 'game_invite',
                        type_id: type_id,
                        channel: self.stream.channel,
                        host_id: self.stream.id
                    }
                })
                    .then(function () {
                        self.stream.game_invitation_sent = true;
                    });
                self.$refs.uiDialog.alert('', self.lang.games.invitation_sent);
            },
            endGame: function() {
                if(this.stream.game) {
                    Vue.set(this.stream, 'game', null);
                }
            },
            onGameEnd: function (data) {
                let self = this;
                let name = self.stream.user_name;
                let type_id = self.stream.game.type_id;
                let role = self.stream.game.role;
                window.setTimeout(function () {
                    self.endGame();
                }, 3000);
                if(role === self.GAME_ROLE_PLAYER) {
                    window.setTimeout(function () {
                        if(data.winner && (data.winner === self.me.id)) {
                            self.$refs.uiDialog.prompt(self.lang.games.win_t.replace('{name}', name), self.lang.games.win_h)
                                .then(function (result) {
                                    $.ajax({
                                        method: 'POST',
                                        url: '/streaming.ajax.php',
                                        data: {
                                            action: 'game_wish',
                                            type_id: type_id,
                                            channel: self.stream.channel,
                                            host_id: self.stream.id,
                                            wish: result
                                        }
                                    })
                                        .then(function () {
                                        });
                                }, function () {

                                });
                        }
                    }, 1000);
                }
            },
            onPartnerLeft: function () {
                this.endGame();
            },
            onGameWarnMove: function () {
                this.$refs.uiDialog.alert('', this.lang.games.warn_move.replace('{name}', this.stream.user_name));
            },
            onGameExpiredMove: function () {
                this.endGame();
            },
            escapeText: function(text) {
                let tmp_node = document.createElement('div');
                tmp_node.innerText = text;
                return tmp_node.innerHTML;
            },
            remindDiamondsTarget: function () {
                let self = this;
                if(this.stream_target_is_set) {
                    this.$refs.uiTooltipDiamondTarget.alert_raw(
                        this.lang.diamonds_target.remind
                            .replace(/{name}/g, this.stream.user_name)
                            .replace('{x}', this.stream.user_diamonds_target)
                        + "<br/>" + "<strong>" + self.escapeText(this.stream.user_diamonds_target_action) + "</strong>",
                        this.$refs.userDiamonds
                    )
                        .then(function() {
                            self.$refs.sendDiamonds.highlight();
                        }, function () {

                        });
                }
            },
            remindGifts: function() {
                const phrase = this.lang.gift_tips[ Math.round( Math.random() * (this.lang.gift_tips.length - 1) ) ];
                this.$refs.uiTooltipVirtualGift.alert(phrase, this.$refs.giftsBlockWrap, {
                    timeout_ok: 6000,
                    position: 'top'
                });
            },
            onDiamondsTargetReached: function () {
                this.$refs.uiDialog.no();
                this.$refs.uiDialog.alert(
                    this.escapeText(this.stream.user_diamonds_target_action),
                    this.lang.diamonds_target.reached
                        .replace(/{name}/g, this.stream.user_name)
                );
            }
        },
        computed: {
            price_per_hour: function () {
                return this.minutes_batch_price * parseInt(60 / this.minutes_batch);
            },
            stream_target_is_set: function () {
                return this.stream.user_diamonds_target > this.stream.user_diamonds;
            },
            streaming_halted_phrase: function () {
                const tpl = [0,2,4].indexOf(this.stream.user_gender) > -1 ?
                    this.lang.streaming_stream_halted_male : this.lang.streaming_stream_halted_female;
                return tpl
                    .replace('{name}', this.stream.user_name);
            }
        },
        mounted: function () {
            let self = this;
            this.guest_mode = !!this.me.id.match(/^gst_/);
            this.initWs();
            this.getStreams()
                .then(function () {
                    let idx = 0;
                    if (self.begin_with_id) {
                        idx = self.streams.findIndex((v) => v.id == self.begin_with_id);
                        if (idx < 0) {
                            idx = 0;
                        }
                    }
                    if (self.streams.length > 0) {
                        self.streams_index = idx;
                        self.setStream(self.streams[idx]);
                        self.initVideo();
                    }
                });
            window.addEventListener('beforeunload', self.beforeUnload);
            self.keepalive_timer = window.setInterval(self.keepAlive, 30000);
            window.addEventListener('diamonds:bought', self.onDiamondsBought);
        },
        beforeUnmount: function () {
            window.removeEventListener('beforeunload', self.beforeUnload);
            window.clearInterval(self.keepalive_timer);
            window.removeEventListener('diamonds:bought', self.onDiamondsBought);
        }
    });
};